module.exports = __webpack_public_path__ + "img/about.71814be2.png";